import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
import { authenticationTypes } from 'root/src/shared/constants/auth';
import { VALIDATE_TOKEN_ACCOUNT } from 'root/src/shared/descriptions/middlewares/middlewareIds';
import { pointsEndpointIds } from 'root/src/shared/points/points.constants';
import { AuthGroup } from 'root/src/server/util/awsClients/authApiClient.types';
export const awardPointsAdminEndpoint = {
    [pointsEndpointIds.AWARD_POINTS_ADMIN]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: AuthGroup.Admin,
        endpointType: otherEndpointType,
        payloadSchema: {
            type: 'object',
            properties: {
                userId: { type: 'string' },
                dropId: { type: 'string' },
                value: { type: 'integer', minimum: 1 },
            },
            required: ['userId', 'dropId', 'value'],
            additionalProperties: false,
        },
        middlewares: [VALIDATE_TOKEN_ACCOUNT],
    },
};
